import React from 'react';
import { DynamicSectionRenderer } from '../DynamicSectionRenderer';
import { SHARED_UI_LABELS } from '@/config/task-display-config';

/**
 * KBTaskDetail - Contract-Driven KB Article Renderer
 * Authority: Law 65.1 + Law 66.1 (No hard-coded labels)
 */

const FALLBACK_CONFIG = {
    sections: [
        { field: "summary", label: null, render_type: "text", required: true },
        { field: "rationale", label: SHARED_UI_LABELS.whyThisMatters, render_type: "callout", required: false },
        { field: "analysis", label: "Analysis", render_type: "text", required: false }
    ]
};

import { DecisionFooter } from '../DecisionFooter';

export function KBTaskDetail({ item, uiConfig, onAccept, onReject }) {
    const renderConfig = uiConfig || FALLBACK_CONFIG;

    if (!renderConfig || !renderConfig.sections) {
        return <ContractText variant="caption" className="text-muted-foreground">No render configuration available</ContractText>;
    }

    return (
        <div className="flex flex-col h-full">
            <div className="flex-1 overflow-y-auto p-1">
                <DynamicSectionRenderer sections={renderConfig.sections} item={item} />
            </div>

            {/* Phase 1 Remediation: Global UI Law Compliance */}
            <DecisionFooter
                onAccept={() => onAccept && onAccept(item.id, item.work_type)}
                onReject={(rationale) => onReject && onReject(item.id, rationale, item.work_type)}
            />
        </div>
    );
}
